import React, { useState, useEffect, useReducer } from 'react';
import {
  Radio,
  Form,
  Collapse,
  Button
} from 'antd';
import { ArrowUpOutlined , PlusOutlined } from '@ant-design/icons';
import { toThousands } from '../../utils/Numeric';

const { Panel } = Collapse;
const text = (
  <p style={{ paddingLeft: 24 }}>
    A dog is a type of domesticated animal. Known for its loyalty and faithfulness, it can be found
    as a welcome guest in many households across the world.
  </p>
);

export default React.forwardRef((props, ref) => {
  const { packages } = props;
  const genExtra = () => (
    <div style={{display:'flex', justifyContent:'end', alignItems:'center'}}>
      <Button size="small"
        icon={<ArrowUpOutlined  />}
        onClick={event => {
          event.preventDefault();
          event.stopPropagation();
        }}
      >移动到指定托盘...</Button>
      <div>&nbsp;</div>
      <Button size="small"
        type="primary"
        icon={<PlusOutlined />}
        onClick={event => {
          event.preventDefault();
          event.stopPropagation();
        }}
      >合并为新托盘</Button>
      </div>
  );

  const total = {
    count: 0,
    weight: 0,
    amount: 0,
  }
  packages.forEach((x) => {
    total.weight += (x.weight || 0);
    total.count += (x.count_per_carton * x.carton_count);
    total.amount += (x.count_per_carton * x.carton_count * x.price);
  })

  return (
    <Collapse>
      <Panel header={`散箱 [ 80箱 ${30}Kg ]`} key='cartons' extra={genExtra()}>
        <table style={{ border: '1px solid #f0f0f0' }} className="table">
          <thead style={{ backgroundColor: '#f0f0f0' }}>
            <tr>
              <th className="th" rowSpan="2" >规格名称</th>
              <th className="th" rowspan="2" >箱数</th>
              <th className="th2" colspan="2">数量(件)</th>
              <th className="th2" rowSpan="2">重量<br />(千克)</th>
              <th className="th2" rowSpan="2">总重量<br />(千克)</th>
              <th className="th2" colspan="2">金额(元)</th>
              <th className="th2" width="68px" rowspan="2"></th>
            </tr>
            <tr>
              <th align="center" className="th2">件数/箱</th>
              <th align="center" className="th2">总件数</th>
              <th align="center" className="th2">单价</th>
              <th align="center" className="th2">总金额</th>
            </tr>
          </thead>
          <tbody>
            {
              packages.map((carton, index) => {
                return <tr>
                  <td className="td">{carton.goods_name} {carton.goods_specname} {carton.size} </td>
                  <td align="right" className="td">{toThousands(carton.carton_count)}</td>
                  <td align="right" className="td">{toThousands(carton.count_per_carton)}</td>
                  <td align="right" className="td">{toThousands(carton.carton_count * carton.count_per_carton)}</td>
                  <td align="right" className="td">{toThousands(carton.weight.toFixed(2))}</td>
                  {
                    index === 0 && <td align="right" className="td" rowspan={packages.length}>{toThousands(total.weight.toFixed(2))}</td>
                  }
                  <td align="right" className="td">{toThousands(carton.price.toFixed(2))}</td>
                  <td align="right" className="td">{toThousands((carton.price * carton.count_per_carton * carton.carton_count).toFixed(2))}</td>
                  {
                    <td align="center" className="td">
                      <Button onClick={() => alert(carton)} size="small" type="link" >移出到散箱</Button>
                      <Button onClick={() => alert(carton)} size="small" type="link">移动到其他托盘</Button>
                    </td>
                  }
                </tr>
              })
            }
          </tbody>
          <tfoot style={{ backgroundColor: '#f0f0f0' }}>
            <td className="td" colSpan="2">
              <div style={{ fontSize: '1.1rem' }}>
                <strong>合计： {packages.length}散箱</strong>
              </div>
            </td>
            <td className="td" colSpan="2">
              <div style={{ textAlign: 'right', fontSize: '1.1rem' }}>
                <strong>总数量:  {toThousands(total.count)}</strong>
              </div>
            </td>
            <td className="td" colSpan="2">
              <div style={{ textAlign: 'right', fontSize: '1.1rem' }}>
                <strong>总重量:  {toThousands(total.weight.toFixed(2))}</strong>
              </div>
            </td>
            <td className="td" colSpan="2">
              <div style={{ textAlign: 'right', fontSize: '1.1rem' }}>
                <strong>总金额:  {toThousands(total.amount.toFixed(2))}</strong>
              </div>
            </td>
            <td className="td"></td>
          </tfoot>
        </table>
      </Panel>
    </Collapse>
  );
});